import type { ImpactMaterial } from '../events';
import { HazardKind } from '../traits';

export function impactMaterial(kind: number | undefined, theme: string): ImpactMaterial {
  if (kind === HazardKind.Crate) return 'wood';
  if (kind === HazardKind.Ice) return 'ice';
  if (kind !== undefined && ![HazardKind.Solid, HazardKind.Destructible].includes(kind as 0 | 1)) return 'metal';
  if (theme === 'woods' || theme === 'western' || theme === 'pirate') return 'wood';
  if (theme === 'factory' || theme === 'laser' || theme === 'neon') return 'metal';
  return 'stone';
}
